<div id="partners-notes" class="popup maintenance-form">
    <div class="heading">Partner's notes - {$user.last_partner}</div>
    <div class="container" id="partners-notes-text">{@html partners_notes}</div>
    <div class="button-grid">
        <button class="select-button" on:click={close}>Close</button>
    </div>
</div>

<style>

    #partners-notes {
        display: none;
        flex-direction: column;
    }
    .container {
        border: 0.25vh solid black;
        border-radius: 1vh;
    }

    .heading {
        margin: 0 auto;
        font-size: 2vh;
    }

    #partners-notes-text {
        width: 48vw;
        height: 66vh;
        background-color: white;
        padding: 1vh;
    }

    .button-grid {
        padding-top: 0.5vh;
        margin: 0 auto;
    }
</style>

<script>
    import { elementDisplay, isUndefined } from './utilities'
    import { user } from './data-store'
    import { textToSuit } from './common';

    $: partners_notes = getPartnersNotes($user);

    function getPartnersNotes() {
        let partner = $user.partners[$user.last_partner];
        if (!isUndefined(partner)) {
            let text = textToSuit(partner.notes);
            text = text.replaceAll('\n', '<br>');
            return text;
        }
    }

    function close() {
        elementDisplay('partners-notes', 'none')
    }
</script>